import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routeTitles } from '../config/routeTitles';

const APP_NAME = 'Fluents';

export const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const updateTitle = () => {
      const pathname = location.pathname;

      let routeConfig = routeTitles[pathname];

      if (!routeConfig) {
        const dynamicRoute = Object.keys(routeTitles).find((route) => {
          const routePattern = route.replace(/:\w+/g, '[^/]+');
          const regex = new RegExp(`^${routePattern}$`);
          return regex.test(pathname);
        });

        if (dynamicRoute) {
          routeConfig = routeTitles[dynamicRoute];
        }
      }

      if (routeConfig) {
        document.title = `${APP_NAME} - ${routeConfig.title}`;
      } else {
        document.title = APP_NAME;
      }
    };

    updateTitle();
  }, [location.pathname]);
};
